"use client";

import React from "react";
import { Loader } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
function JournalGrid() {
  const {
    posts,
    loading,
    loadMore,
    hasNext,
    isRefetching
  } = usePosts();
  if (loading && posts.length === 0) {
    return <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
        {[...Array(6)].map((_, i) => <div key={i} className="break-inside-avoid mb-8">
            <div className="w-full h-64 bg-muted/20 animate-pulse rounded-xl" />
            <div className="mt-4 h-6 w-3/4 bg-muted/20 animate-pulse rounded" />
            <div className="mt-2 h-4 w-full bg-muted/20 animate-pulse rounded" />
          </div>)}
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-20">
        <p className="text-muted-foreground font-sans text-lg">No journal entries found.</p>
      </div>;
  }
  return <div className="space-y-16">
      <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
        {posts.map((post, i) => <Card key={post.id} data-index={i} className="break-inside-avoid border-none shadow-none bg-transparent p-0 group mb-8 inline-block w-full">
            <div className="relative overflow-hidden rounded-xl mb-5 bg-muted/10">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" /> : <div className="w-full h-64 bg-secondary/30 flex items-center justify-center text-muted-foreground">
                  <span className="font-serif italic">No Image</span>
                </div>}
              
              {}
              {post.link && <Link to={post.link} className="absolute inset-0 bg-[var(--color-chart-1)]/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center z-10">
                  <span className="text-white font-sans font-medium tracking-widest uppercase text-sm border-b border-white/50 pb-1">
                    Read More
                  </span>
                </Link>}
            </div>

            <CardHeader className="p-0 space-y-3">
              <div className="flex items-center gap-3 text-xs font-medium tracking-widest uppercase text-muted-foreground">
                {post.categories && post.categories.length > 0 && <span className="text-[var(--color-chart-1)]">{post.categories[0].name}</span>}
                {post.date && <>
                    <span className="w-1 h-1 rounded-full bg-muted-foreground/30" />
                    <span>{new Date(post.date).toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}</span>
                  </>}
              </div>
              
              <CardTitle className="font-serif text-2xl md:text-3xl font-bold leading-tight text-foreground group-hover:text-[var(--color-chart-1)] transition-colors duration-300">
                {post.link ? <Link to={post.link}>{post.title}</Link> : post.title}
              </CardTitle>
            </CardHeader>

            <CardContent className="p-0 mt-3">
              <div className="text-muted-foreground font-sans leading-relaxed line-clamp-3" dangerouslySetInnerHTML={{
            __html: post.excerpt || ""
          }} />
            </CardContent>
          </Card>)}
      </div>

      {hasNext && <div className="flex justify-center pt-8 pb-4">
          <Button onClick={async () => await loadMore()} disabled={isRefetching} className="bg-secondary text-secondary-foreground hover:bg-secondary/80 px-10 py-6 rounded-full text-base font-medium tracking-wide min-w-[200px] shadow-sm hover:shadow-md transition-all">
            {isRefetching ? <>
                <Loader className="mr-2 h-4 w-4 animate-spin" />
                Loading...
              </> : "Load More Articles"}
          </Button>
        </div>}
    </div>;
}
export default function JournalArchives() {
  const wp_query_params = {
    per_page: 9,
    orderby: "date",
    order: "desc",
    status: "publish"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="journal-archives" className="bg-background py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="max-w-2xl mx-auto text-center mb-20">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium text-foreground mb-6">
            The Journal
          </h2>
          <p className="text-lg text-muted-foreground font-sans leading-relaxed">
            Explore our collection of organization tips, decluttering guides, and minimalist living inspiration for your home.
          </p>
        </div>

        <PostsProvider wp_query={{
        per_page: 9,
        orderby: "date",
        order: "desc",
        status: ["publish"]
      }}>
          <JournalGrid />
        </PostsProvider>
      </div>
    </section>;
}